import { IzumiMessageKey } from 'izumi/IzumiMessageKey'
import { i18n } from 'lib/i18n'
import React from 'react'

interface TranslateWithLinkProps {
  translationKey: IzumiMessageKey
  url: string
  data?: string[] | number[]
}

const LINK_REGEX = /.*(<link>.*?<\/link>).*/g

/**
 *
 * @description While we do not migrate to react i18n we need a way to map links within the app
 * you will need to add the same translation key to lib/config translationKeyConfig
 * @todo The current implementation does not support multiple links
 */
export const TranslateWithLink = ({
  translationKey,
  data,
  url,
}: TranslateWithLinkProps): JSX.Element => {
  const rawTranslation = i18n(translationKey, data)

  const match = rawTranslation.split(LINK_REGEX).filter((str) => str)[0]

  const rest = rawTranslation.split(match)

  const insideText = match.replace('<link>', '').replace('</link>', '')

  return (
    <>
      {rest[0]}
      <a href={url} target="_blank" rel="noreferrer">
        {insideText}
      </a>
      {rest[1]}
    </>
  )
}
